export default __webpack_public_path__ + "img/bSVpUhEM.6dcdfc20.svg";